module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"verify_email_address":"Verify email address","verify":"Verify"},"id":{"verify_email_address":"verifikasi email","verify":"Verifikasi"}}')
  delete Component.options._Ctor
}
